import type { Components, Theme } from '@mui/material/styles';
import { components as dsComponents } from '@openx/design-system/theme/components';

export type DesignSystemComponentKey = keyof Components<Theme>;

// Migration helper: a component adopting the DS renders its subtree in `<ThemeProvider theme={scopeDesignSystem([...])}>`.
// The returned function receives the OUTER theme (core theme, or another scope) and swaps in the DS definitions of the
// listed keys only. Keys are REPLACED, not deep-merged, so legacy overrides of an owned key (incl. `!important` rules)
// do not exist inside the scope. Every other key is inherited from the outer theme, so scopes of different components
// compose. Global CSS and keys that are not listed still reach the subtree.
// Delete together with its call sites once apps render the DS theme at the root.
export const scopeDesignSystem =
  (keys: readonly DesignSystemComponentKey[]) =>
  (outer: Theme): Theme => ({
    ...outer,
    components: {
      ...outer.components,
      ...Object.fromEntries(keys.map(key => [key, dsComponents[key]])),
    },
  });
